import { CircularProgress } from '@mui/material';
import { Box, styled } from '@mui/system';

const StyledLoading = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: 'auto',
    height: '45px',
  },
  '& .circleProgress': {
    position: 'absolute',
    left: -17,
    right: 0,
    top: 'calc(50% - 42px)',
  },
}));

const Loading = () => {
  return (
    <StyledLoading>
      <Box position="relative">
        <img src="/admin-panel/assets/images/logo-circle.svg" alt="" />
        <CircularProgress className="circleProgress" size={80} thickness={2}/>
      </Box>
    </StyledLoading>
  );
};

export default Loading;
